import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["srcset", "media"]
const _hoisted_2 = ["srcset", "media"]
const _hoisted_3 = ["srcset", "media"]
const _hoisted_4 = ["srcset", "media"]
const _hoisted_5 = ["src", "alt", "width", "height", "loading", "fetchpriority"]
const _hoisted_6 = ["srcset"]
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt", "width", "height", "loading", "fetchpriority"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["srcset"]
const _hoisted_11 = ["srcset"]
const _hoisted_12 = ["src", "alt", "width", "height", "loading", "fetchpriority"]
const _hoisted_13 = ["src", "alt", "width", "height", "loading"]
const _hoisted_14 = {
  key: 4,
  class: "image-element__ai-labels | image-ai-labels"
}

import {computed, ref, watch} from 'vue';
  import jsGlobalConfig from '../../globals/jsGlobalConfig';
  import diContainer from '../../utilities/js/diContainer/diContainer';
  import type {TransformerPipeline} from '../../utilities/js/imageUrlTransformer/TransformerPipeline';
  import {t} from '../../utilities/js/translations/translations';

  interface ImageElementProps {
    src: string[];
    srcMobile?: string[];
    alt?: string;
    breakpoint?: number;
    width?: number|string;
    height?: number|string;
    pictureClass?: string;
    imgClass?: string;
    fallbackUrl?: string;
    webp?: boolean;
    loading?: 'lazy' | 'eager';
    fetchpriority?: string | null;
    aiLabels?: Array<'generated' | 'modified'>;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'imageElement',
  props: {
    src: {},
    srcMobile: { default: null },
    alt: { default: null },
    breakpoint: { default: 767 },
    width: { default: 200 },
    height: { default: 100 },
    pictureClass: { default: '' },
    imgClass: { default: '' },
    fallbackUrl: { default: '' },
    webp: { type: Boolean, default: false },
    loading: { default: 'lazy' },
    fetchpriority: { default: null },
    aiLabels: { default: null }
  },
  setup(__props: any) {

  const props = __props;

  const isError = ref(false);
  const imgSrc = ref('');
  const imgSrcMobile = ref('');
  const imgSrcDesktop = ref('');

  const productImgUrlPattern = /\/{2}[^/]+\/[^/]+\/[\w,\s-]+\.(png|jpg)/g;
  const imageUrlTransformer: TransformerPipeline = diContainer.get('imageUrlTransformer');

  const getFullSrcString = (srcArray: string[]) => {
    if (!srcArray || srcArray.length < 1) {
      return '';
    }

    const src = [];
    for (let i = 0, l = srcArray.length; i < l; i += 1) {
      src.push(`${imageUrlTransformer.execute(srcArray[i])} ${i + 1}x`);
    }
    return src.join(', ');
  };

  const errorHandler = () => {
    const fallback = props.fallbackUrl || jsGlobalConfig().getFallbackImage();
    imgSrc.value = fallback;
    if (imgSrcMobile.value) {
      imgSrcMobile.value = fallback;
    }
    if (imgSrcDesktop.value) {
      imgSrcDesktop.value = fallback;
    }
    isError.value = true;
  };

  const setImageUrls = () => {
    imgSrc.value = props.src ? imageUrlTransformer.execute(props.src[0]) : '';
    imgSrcMobile.value = props.srcMobile ? getFullSrcString(props.srcMobile) : '';
    imgSrcDesktop.value = ((props.src && props.src.length > 1) || (props.src && imgSrcMobile.value)) ? getFullSrcString(props.src) : '';

    if (!imgSrc.value) {
      errorHandler();
    }
  };

  const isWebpUrl = computed(() => !!imgSrc.value.match(/\.webp$/gi));

  const loadWebp = computed(() => isWebpUrl.value || !!imgSrc.value.match(/\.(png|jpg)$/) && props.webp);

  const getWebpSrc = (src: string) => {
    if (isWebpUrl.value) {
      return src;
    }

    let result = src;
    const urlMatches = src.match(productImgUrlPattern);
    if (urlMatches && urlMatches.length) {
      urlMatches.forEach((url) => {
        const srcArray = url.split('/');
        if (srcArray[3].includes('_90')) {
          srcArray[3] = srcArray[3].includes('retina')
            ? srcArray[3].replace('_retina_90', '_transparent_retina_webp')
            : srcArray[3].replace('_90', '_transparent_webp');
        } else {
          srcArray[3] += '_webp';
        }
        result = result.replace(url, srcArray.join('/'));
      });
      result = result.replace(/(\.jpg|\.png)/g, '.webp');
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Image Source mismatch: ${src}`);
    }

    return result;
  };

  const getWebpFallbackSrc = (src: string) => {
    const fallbackFormat = imgSrc.value.match(/\.png$/) ? 'png' : 'jpg';
    return src
      .replace('/master/', `/bo_${fallbackFormat}/`)
      .replace('.webp', `.${fallbackFormat}`);
  };

  watch([
    () => props.src,
    () => props.srcMobile
  ], setImageUrls, {immediate: true});

  const aiLabelsList = computed(() => {
    return props.aiLabels?.filter(label => !!t(`general.ai.image_${label}`))
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("figure", {
    class: _normalizeClass(["image-element", {
      'image-element--load-error': isError.value
    }])
  }, [
    (imgSrcMobile.value && imgSrcDesktop.value && imgSrc.value)
      ? (_openBlock(), _createElementBlock("picture", {
          key: 0,
          class: _normalizeClass(["image-element__pic", _ctx.pictureClass])
        }, [
          (loadWebp.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("source", {
                  srcset: getWebpSrc(imgSrcMobile.value),
                  media: `(max-width: ${_ctx.breakpoint}px)`,
                  type: "image/webp"
                }, null, 8 /* PROPS */, _hoisted_1),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("source", {
                  srcset: getWebpSrc(imgSrcDesktop.value),
                  media: `(min-width: ${_ctx.breakpoint}px)`,
                  type: "image/webp"
                }, null, 8 /* PROPS */, _hoisted_2)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createElementVNode("source", {
            srcset: getWebpFallbackSrc(imgSrcMobile.value),
            media: `(max-width: ${_ctx.breakpoint}px)`
          }, null, 8 /* PROPS */, _hoisted_3),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("source", {
            srcset: getWebpFallbackSrc(imgSrcDesktop.value),
            media: `(min-width: ${_ctx.breakpoint}px)`
          }, null, 8 /* PROPS */, _hoisted_4),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("img", {
            class: _normalizeClass(["image-element__img", _ctx.imgClass]),
            src: imgSrc.value,
            alt: _ctx.alt,
            width: _ctx.width,
            height: _ctx.height,
            loading: _ctx.loading,
            fetchpriority: _ctx.fetchpriority,
            onError: errorHandler
          }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5)
        ], 2 /* CLASS */))
      : (!imgSrcMobile.value && imgSrcDesktop.value && imgSrc.value)
        ? (_openBlock(), _createElementBlock("picture", {
            key: 1,
            class: _normalizeClass(["image-element__pic", _ctx.pictureClass])
          }, [
            (loadWebp.value)
              ? (_openBlock(), _createElementBlock("source", {
                  key: 0,
                  srcset: getWebpSrc(imgSrcDesktop.value),
                  type: "image/webp"
                }, null, 8 /* PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createElementVNode("source", {
              srcset: getWebpFallbackSrc(imgSrcDesktop.value)
            }, null, 8 /* PROPS */, _hoisted_7),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("img", {
              class: _normalizeClass(["image-element__img", _ctx.imgClass]),
              src: imgSrc.value,
              alt: _ctx.alt,
              width: _ctx.width,
              height: _ctx.height,
              loading: _ctx.loading,
              fetchpriority: _ctx.fetchpriority,
              onError: errorHandler
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_8)
          ], 2 /* CLASS */))
        : (loadWebp.value)
          ? (_openBlock(), _createElementBlock("picture", _hoisted_9, [
              _createElementVNode("source", {
                srcset: getWebpSrc(imgSrc.value),
                type: "image/webp"
              }, null, 8 /* PROPS */, _hoisted_10),
              _cache[6] || (_cache[6] = _createTextVNode()),
              _createElementVNode("source", {
                srcset: getWebpFallbackSrc(imgSrc.value),
                media: "(min-width: 1px)"
              }, null, 8 /* PROPS */, _hoisted_11),
              _cache[7] || (_cache[7] = _createTextVNode()),
              _createElementVNode("img", {
                class: _normalizeClass(["image-element__img", _ctx.imgClass]),
                src: imgSrc.value,
                alt: _ctx.alt,
                width: _ctx.width,
                height: _ctx.height,
                loading: _ctx.loading,
                fetchpriority: _ctx.fetchpriority,
                onError: errorHandler
              }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_12)
            ]))
          : (_openBlock(), _createElementBlock("img", {
              key: 3,
              class: _normalizeClass(["image-element__img", _ctx.imgClass]),
              src: imgSrc.value,
              alt: _ctx.alt,
              width: _ctx.width,
              height: _ctx.height,
              loading: _ctx.loading,
              onError: errorHandler
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_13)),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (aiLabelsList.value && aiLabelsList.value.length)
      ? (_openBlock(), _createElementBlock("figcaption", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiLabelsList.value, (label, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: _normalizeClass(["image-element__ai-labels | image-ai-labels__item", `image-ai-labels__item--${label}`])
            }, _toDisplayString(_unref(t)(`general.ai.image_${label}`)), 3 /* TEXT, CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})